import { render } from "./ProyectoConfiguracion.vue?vue&type=template&id=85657424&scoped=true"
import script from "./ProyectoConfiguracion.vue?vue&type=script&lang=js"
export * from "./ProyectoConfiguracion.vue?vue&type=script&lang=js"

import "./ProyectoConfiguracion.vue?vue&type=style&index=0&id=85657424&lang=scss&scoped=true"

import exportComponent from "/home/cubel/PhpstormProjects/failder/vue-failder/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85657424"]])

export default __exports__